<ui-content-header
	title="Create a Closer Matter in LEAP"
	type="dialog"
	[testHook]="testHooks.CreateACloserMatterInLeapContentHeader"
>
</ui-content-header>
<div class="flex flex-col gap-8 p-6">
	<div>
		Go to the Matters tab, click “New Matter,” choose your file type, and you’re
		ready to roll!
	</div>
	<div class="w-full">
		<img src="/assets/images/leap/leap-create-matter-instructions.gif" />
	</div>
</div>
